import { render, staticRenderFns } from "./RuleEditPage.vue?vue&type=template&id=0fdcc762"
import script from "./RuleEditPage.vue?vue&type=script&lang=ts"
export * from "./RuleEditPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports